var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "swap-item-container" },
    [
      _c("img", {
        staticClass: "close-modal",
        attrs: { src: _vm.imageUrl("close-modal.png") },
        on: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.closeSwapModal.apply(null, arguments)
          }
        }
      }),
      _vm._v(" "),
      !_vm.noProductsFoundMessage
        ? _c(
            "div",
            {
              staticClass: "title replacement",
              class: { hasProducts: _vm.substituteProducts.length }
            },
            [_vm._v("\n        Swipe to find a replacement Item\n    ")]
          )
        : _c("div", { staticClass: "title fade-in" }, [
            _vm._v("\n         No Substitute Items Found\n     ")
          ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.substituteProducts.length
            ? _c("slideshow", {
                attrs: {
                  images: _vm.substituteProducts.map(function(product) {
                    return product.product_image_url
                  }),
                  zoomImages: _vm.substituteProducts.map(function(product) {
                    return product.product_image_zoom_uri
                  }),
                  product: true,
                  classes: { "swap-container": true },
                  slideshowHeight: "31vh"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticClass: "loading-overlay"
          },
          [_c("loader")],
          1
        )
      ]),
      _vm._v(" "),
      _vm.substituteProducts.length
        ? _c("div", { staticClass: "product-info" }, [
            _vm.substituteProducts[_vm.index].product_brand
              ? _c("div", { staticClass: "product-brand" }, [
                  _vm._v(
                    _vm._s(_vm.substituteProducts[_vm.index].product_brand) +
                      "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "product-title" }, [
              _vm._v(_vm._s(_vm.substituteProducts[_vm.index].product_title))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "product-price" }, [
              _vm._v(
                _vm._s(
                  _vm._f("currency")(
                    _vm.substituteProducts[_vm.index].product_price
                  )
                )
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "buttons-container" }, [
        _c("div", { staticClass: "wtw-container small" }, [
          _c(
            "div",
            {
              staticClass: "button pink full-width",
              class: {
                disabled: !_vm.substituteProducts.length || _vm.loading
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.swapProduct.apply(null, arguments)
                }
              }
            },
            [_vm._v("\n                Swap it!\n            ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "button outline full-width",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.closeSwapModal.apply(null, arguments)
                }
              }
            },
            [_vm._v("Nevermind")]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ac4414e", { render: render, staticRenderFns: staticRenderFns })
  }
}